import { unlock } from '@portal/utils/util-body-scroll-lock';
import { componentFactoryOf } from 'vue-tsx-support';

import { ConfirmParams } from '../../../../features/user/feature-confirm-register-modal/src/lib/confirm-register-modal/confirm-register-modal';

// eslint-disable-next-line @typescript-eslint/naming-convention
const AuthModal = () =>
  import(
    /* webpackChunkName: "auth-modal" */ '../../../../features/user/feature-auth-modal/src/lib'
  ).then(m => m.AuthModal);

// eslint-disable-next-line @typescript-eslint/naming-convention
const RegisterModal = () =>
  import(
    /* webpackChunkName: "register-modal" */ '../../../../features/user/feature-register-modal/src/lib/register-modal'
  ).then(m => m.RegisterModal);

// eslint-disable-next-line @typescript-eslint/naming-convention
const ConfirmRegisterModal = () =>
  import(
    /* webpackChunkName: "confirm-register-modal" */ '../../../../features/user/feature-confirm-register-modal/src/lib/confirm-register-modal'
  ).then(m => m.ConfirmRegisterModal);

type ComponentData = {
  isAuthModalOpen: boolean;
  isAuthModalRendered: boolean;
  isRegisterModalOpen: boolean;
  isRegisterModalRendered: boolean;
  isRegisterConfirmModalOpen: boolean;
  isRegisterConfirmModalRendered: boolean;
  confirmParams: ConfirmParams | null;
};

type Events = {
  onChangeModalState: (isOpen: boolean) => void;
};

type ModalType = 'auth' | 'register';

export type AuthParams = {
  openAfterAuth?: string;
  openFrom?: string;
  typeProfile?: string;
  login?: string;
};

export default componentFactoryOf<Events>().create({
  name: 'AuthAndRegisterModal',
  model: {
    prop: 'isOpen',
    event: 'changeModalState'
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object as () => AuthParams | null,
      default: null
    },
    modalType: {
      type: String as () => ModalType,
      default: 'auth'
    }
  },
  data(): ComponentData {
    return {
      isAuthModalOpen: false,
      isAuthModalRendered: false,
      isRegisterModalOpen: false,
      isRegisterModalRendered: false,
      isRegisterConfirmModalOpen: false,
      isRegisterConfirmModalRendered: false,
      confirmParams: null
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.openModalInit();
      }
    }
  },
  computed: {
    isCloseModal(): boolean {
      return (
        !this.isAuthModalOpen &&
        !this.isRegisterModalOpen &&
        !this.isRegisterConfirmModalOpen
      );
    }
  },
  methods: {
    openConfirmModal(params: ConfirmParams): void {
      this.confirmParams = params;
      this.isRegisterConfirmModalOpen = true;
      this.isRegisterConfirmModalRendered = true;
    },
    openAuthModal(): void {
      this.isAuthModalOpen = true;
      this.isAuthModalRendered = true;
    },
    openRegisterModal(): void {
      this.isRegisterModalOpen = true;
      this.isRegisterModalRendered = true;
    },
    changeModalState(): void {
      if (this.isCloseModal) {
        this.confirmParams = null;
        this.isAuthModalRendered = false;
        this.isRegisterModalRendered = false;
        this.isRegisterConfirmModalRendered = false;
        this.$emit('changeModalState', !this.isOpen);
        unlock();
      }
    },
    openModalInit(): void {
      if (this.modalType === 'register') {
        this.openRegisterModal();
        return;
      }
      this.openAuthModal();
    }
  },
  mounted() {
    this.openModalInit();
  },
  render() {
    return (
      <div>
        {this.isOpen && (
          <div>
            {this.isAuthModalRendered && (
              <AuthModal
                vModel={this.isAuthModalOpen}
                params={this.params}
                onShowRegisterModal={() => this.openRegisterModal()}
                onShowConfirmRegisterModal={(params: ConfirmParams) =>
                  this.openConfirmModal(params)
                }
                onCloseModal={() => this.changeModalState()}
              />
            )}
            {this.isRegisterModalRendered && (
              <RegisterModal
                vModel={this.isRegisterModalOpen}
                onShowAuthModal={() => this.openAuthModal()}
                onShowConfirmRegisterModal={(params: ConfirmParams) =>
                  this.openConfirmModal(params)
                }
                onCloseModal={() => this.changeModalState()}
              />
            )}
            {this.isRegisterConfirmModalRendered && (
              <ConfirmRegisterModal
                vModel={this.isRegisterConfirmModalOpen}
                params={this.confirmParams}
                onShowAuthModal={() => this.openAuthModal()}
                onShowRegisterModal={() => this.openRegisterModal()}
                onCloseModal={() => this.changeModalState()}
              />
            )}
          </div>
        )}
      </div>
    );
  }
});
